// extracted by mini-css-extract-plugin
export var menuIcon = "_qr-0";
export var menuIconInline = "_qr-1";